import { React, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { apex } from '../apex';
import { withRouter } from 'react-router';
import {
  login,
  logout,
  AUTH_2FA_REQUIRED,
  AUTH_SUCCESS,
  ENABLE_2FA_REQUIRED,
  AUTH_ERROR,
} from '@t7x000/apex-web/lib/redux/actions/authActions';
import path from '@t7x000/apex-web/lib/helpers/path';
import FullPageSpinner from '@t7x000/apex-web/lib/components/common/FullPageSpinner/FullPageSpinner';
import { jwtDecode } from 'jwt-decode';
import { useQuery } from '../hook';
import { clearLoginTradeBypass } from '../helpers/loginTradeBypass';

const SilentLogin = ({ handleLogin, isConnected }) => {
  const query = useQuery();
  const token = query.get('token');
  const loginAttemptedRef = useRef(false);

  useEffect(() => {
    if (isConnected) {
      if (token) {
        if (loginAttemptedRef.current) {
          return;
        }
        loginAttemptedRef.current = true;
        handleLogin({ JWTToken: token }, isConnected);
      } else {
        window.location.replace(process.env.REACT_APP_NOMYX_AUTH_URL);
      }
    }
  }, [isConnected, token, handleLogin]);

  return (
    <div>
      <FullPageSpinner pastDelay isVisible />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isConnected: state.wsConnection.isConnected,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleLogin: async (payload) => {
    clearLoginTradeBypass();

    await dispatch((thunkDispatch, getState) => {
      if (getState().auth.isAuthenticated) {
        return thunkDispatch(logout());
      }
    });

    const decodedToken = jwtDecode(payload.JWTToken);
    await apex.connection.RPCPromise('SSOEnsureUser', {
      data: { email: decodedToken.email },
      sig: { algorithm: 'RSA256', value: '' },
      auth: {
        Authorization: payload.JWTToken,
      },
    });

    dispatch(login(payload)).then((action) => {
      if (action.type === AUTH_ERROR) {
        ownProps.history.push(path('/login'));
      } else if (action.type === AUTH_SUCCESS) {
        localStorage.setItem('JWTToken', payload.JWTToken);
        ownProps.history.replace(path(process.env.REACT_APP_DEFAULT_PATH));
      }
      if (action.type === ENABLE_2FA_REQUIRED) {
        ownProps.history.push(path('/enabletwofactorauth'));
      } else if (action.type === AUTH_2FA_REQUIRED) {
        ownProps.history.push(path('/twofactorauth'));
      }
    });
  },
});

const SilentLoginContainer = connect(mapStateToProps, mapDispatchToProps)(SilentLogin);

export default withRouter(SilentLoginContainer);
